/*
  Baci: lazy product-card carousels.
  Cards render only the first photo with the page. The other photos (data-baci-src / data-baci-srcset)
  sit on a transparent placeholder, so nothing ever shows as a broken image, and are fetched:
    - for every card that comes on screen, once the page has finished loading;
    - immediately when the shopper touches, hovers, focuses or swipes a card.
*/
(function () {
  'use strict';
  var GALLERY = '.card-gallery[data-baci-deferred]';
  var PENDING = 'img[data-baci-src]';

  function load(img) {
    var srcset = img.getAttribute('data-baci-srcset');
    var src = img.getAttribute('data-baci-src');
    img.removeAttribute('data-baci-srcset');
    img.removeAttribute('data-baci-src');
    // sizes="auto, ..." cannot be resolved for a slide that is off to the side of the strip, and the
    // browser then over-picks (832px for a ~430px phone slot). The explicit sizes after it are exact.
    var sizes = img.getAttribute('sizes');
    if (sizes && /^\s*auto\s*,/.test(sizes)) img.setAttribute('sizes', sizes.replace(/^\s*auto\s*,\s*/, ''));
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
  }

  function hydrate(gallery) {
    if (!gallery) return;
    var imgs = gallery.querySelectorAll(PENDING);
    for (var i = 0; i < imgs.length; i++) load(imgs[i]);
  }

  function galleryOf(t) {
    return t && t.closest ? t.closest(GALLERY) : null;
  }

  // Shopper intent: touch, hover, keyboard focus.
  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) { hydrate(galleryOf(e.target)); }, { passive: true, capture: true });
  });
  // Any movement of a card's photo strip (swipe, arrows, theme scripts).
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.tagName === 'SLIDESHOW-SLIDES') hydrate(galleryOf(t));
  }, { passive: true, capture: true });

  function start() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll(GALLERY).forEach(hydrate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hydrate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 300px 0px', threshold: 0.01 });

    function watch(root) {
      if (root.matches && root.matches(GALLERY)) io.observe(root);
      if (root.querySelectorAll) root.querySelectorAll(GALLERY).forEach(function (g) { io.observe(g); });
    }
    watch(document);

    // Cards added or re-rendered by filters, sorting and "load more".
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) { if (node.nodeType === 1) watch(node); });
        } else if (m.type === 'attributes' && m.target.hasAttribute('data-baci-src')) {
          var g = galleryOf(m.target);
          if (g) { io.unobserve(g); io.observe(g); }
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-baci-src'] });
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 200);
  }
  if (document.readyState === 'complete') whenIdle(start);
  else window.addEventListener('load', function () { whenIdle(start); }, { once: true });
})();
